import React from 'react';
import { ColumnType, ColumnGroupType } from 'antd/lib/table/interface';
import i18n from 'i18n';
import { wrapTableTitle } from 'components/TableContainer/DefaultTableContainer';
import { WimOperationalQualityI, WimOperationalQualityRow } from 'store/wim/types/platforms';
import { StyledPercentText } from './styles';

export type WimOperationalQualityColumns = {
  metricGroup: ColumnGroupType<WimOperationalQualityI> & {
    title: string;
    children: [ColumnType<WimOperationalQualityI>, ColumnType<WimOperationalQualityI>];
  };
  total: ColumnType<WimOperationalQualityI>;
  byLane: ColumnType<WimOperationalQualityI>;
  laneSlopeVRPMedia: ColumnType<WimOperationalQualityI>;
  slopePercent: ColumnType<WimOperationalQualityI>;
  mediaPercent: ColumnType<WimOperationalQualityI>;
  platePercent: ColumnType<WimOperationalQualityI>;
  validPercent: ColumnType<WimOperationalQualityI>;
  validSize: ColumnType<WimOperationalQualityI>;
};

export const getWimOperationalQualityColumns = (): WimOperationalQualityColumns => {
  return {
    metricGroup: {
      key: 'metricGroup',
      title: i18n.t('wimsOperationalQualityPage.table.columns.metricGroup'),
      children: [
        {
          title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.wim')),
          dataIndex: 'wim',
          key: 'wim',
          sorter: (a, b) => a.wim.localeCompare(b.wim),
          render: (value, record) => {
            const recordTyped = record as WimOperationalQualityRow;
            if (recordTyped.rowSpanInternal === 0) {
              return {
                children: null,
                props: { rowSpan: 0 },
              };
            }

            return {
              children: value,
              props: { rowSpan: recordTyped.rowSpanInternal },
            };
          },
        },
        {
          title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.lane')),
          dataIndex: 'lane',
          key: 'lane',
        },
      ],
    },
    total: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.total')),
      dataIndex: 'total',
      key: 'total',
    },
    byLane: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.byLane')),
      dataIndex: 'byLane',
      key: 'byLane',
    },
    slopePercent: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.slopePercent')),
      className: 'percent-column',
      dataIndex: 'slopePercent',
      key: 'slopePercent',
      render: (slopePercent: number) => <StyledPercentText percent={slopePercent}>{slopePercent}</StyledPercentText>,
    },
    mediaPercent: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.mediaPercent')),
      className: 'percent-column',
      dataIndex: 'mediaPercent',
      key: 'mediaPercent',
      render: (slopePercent: number) => <StyledPercentText percent={slopePercent}>{slopePercent}</StyledPercentText>,
    },
    platePercent: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.platePercent')),
      className: 'percent-column',
      dataIndex: 'platePercent',
      key: 'platePercent',
      render: (slopePercent: number) => <StyledPercentText percent={slopePercent}>{slopePercent}</StyledPercentText>,
    },
    validPercent: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.validPercent')),
      className: 'percent-column',
      dataIndex: 'validPercent',
      key: 'validPercent',
      render: (slopePercent: number) => <StyledPercentText percent={slopePercent}>{slopePercent}</StyledPercentText>,
    },
    validSize: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.validSize')),
      className: 'percent-column',
      dataIndex: 'validSize',
      key: 'validSize',
      render: (slopePercent: number) => <StyledPercentText percent={slopePercent}>{slopePercent}</StyledPercentText>,
    },
    laneSlopeVRPMedia: {
      title: (): JSX.Element => wrapTableTitle(i18n.t('wimsOperationalQualityPage.table.columns.laneSlopeVRPMedia')),
      dataIndex: 'laneSlopeVRPMedia',
      key: 'laneSlopeVRPMedia',
    },
  };
};
